import { Button as ReakitButton } from 'reakit/Button'
import styled from 'styled-components'
import { space, SpaceProps } from 'styled-system'
import { colors } from '~/styles/colors'
import { fonts } from '~/styles/fonts'

export const Placeholder = styled(ReakitButton)<SpaceProps>(
  {
    position: 'relative',
    zIndex: 100, // important because of click blocker on page preview
    background: colors.soft,
    border: '1px dashed #CFD8E5',
    borderRadius: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '0.875rem',
    fontWeight: fonts.text.medium,
    color: colors.slateGray,
    height: 156,
    cursor: 'pointer',

    '&:hover': {
      border: `1px solid ${colors.slateGray}`,
      color: colors.dark,
    },
  },
  space
)
